import { Icon } from "@/components/atoms";
import { Box, Button, Typography } from "@mui/material";
import { COLOR_CODE } from '@/utils/constants/colors';

const EmptyState = ({
    icon = "search_off",
    title = "No data found!",
    description = "Please try a different filter value",
    buttonText = "Reset Filters",
    buttonIcon = "refresh",
    onActionClick,
    customStyle = {}
}) => {
    return (
        <Box
            data-testid="empty-state-container"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                py: 8,
                border: `1px solid ${COLOR_CODE._333333}`,
                ...customStyle
            }}>
            <Icon icon={icon} size="large" sx={{ color: COLOR_CODE._616161 }} />
            <Typography variant="h5" sx={{ color: COLOR_CODE._FFFFFF, fontSize: '1.5rem', fontWeight: 'bold' }}>
                {title}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: '1rem', color: COLOR_CODE._D0D0D0 }}>
                {description}
            </Typography>
            {onActionClick && (
                <Button
                    onClick={onActionClick}
                    variant="outlined"
                    startIcon={<Icon icon={buttonIcon} size="small" />}
                    sx={{
                        mt: 2,
                        color: COLOR_CODE._3387DF,
                        borderColor: COLOR_CODE._3387DF,
                        backgroundColor: 'transparent'
                    }}
                >
                    {buttonText}
                </Button>
            )}
        </Box>
    );
};

export default EmptyState;
